import { Component, Prop, Host, h, State, Fragment } from '@stencil/core';
import _ from 'lodash'
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import sanitizeHtml from 'sanitize-html';
import '../header-component/header-component';
import '../loader-component/loader-component'
// import  'jquery/dist/jquery.slim.js';

import 'fomantic-ui/dist/semantic.min.js'


/**
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/accordionfreetext_component.PNG)

#### Content Type
nypwebc_ct_threelevel

 */


@Component({
  tag: 'threelevel-component',
  styleUrl: 'threelevel-component.css',
  // shadow: true,
   scoped: true
})
export class ThreelevelComponent {



  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
 *Optional - To show/hide header. default is true
 */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;

  /**
 *Optional - To show see All link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All Url
 */
  @Prop() seeallurl: string;

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string = "See All";

  /**
    *Optional - number of items to retrieve
    */
  @Prop() count: number = 100;

  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"


  /**
  *Optional - headertext location
*/
  @Prop() headerlocation: string = "top";





  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";

    /**
   *Required - site url if its sp online site
   */
   @Prop() iconlocation: string = "left";

 /**
 *Optional - Expand /collapse all toggle
 */@Prop() exptoggle: boolean = false

  @State() items: []
  @State() isLoading: boolean = true

  @State() expandallclick: boolean
  @State() expandbuttonclick: boolean =false

  componentDidRender() {


    // if (typeof $ != 'undefined') {
    //   // jQuery is loaded => print the version
    //   console.log($.fn.jquery);
    // }
    // @ts-ignore
    // $('.ui.accordion.sc-threelevel-component').accordion();

    setTimeout(
      function () {

        // if (typeof jQuery != 'undefined') {
        //       console.log("jquery loaded..");
        //   console.log(jQuery.fn.jquery);
        // }
       
        // $(() => {
 
        //   $('.ui.accordion.sc-threelevel-component').accordion();
        // });
        

        // @ts-ignore
       $('.ui.accordion.sc-threelevel-component').accordion();

        // @ts-ignore
        $('.info-popup').popup({
          inline: true,
          hoverable: true,
          position: 'bottom left',
          delay: {
            show: 300,
            hide: 800
          }
        })
          ;

      }, 1000);


    ;





  }
  componentDidLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }



    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }


    // const filter = "nypwebc_Active eq 1";
    const filter = "";

    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_Level1Choice,nypwebc_Level2Choice,nypwebc_Level3Choice,nypwebc_LevelContent,nypwebc_LevelHint&$filter=" + filter + "&$top=" + this.count, { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;


      });
  }


  getHtml = (rawContent: any) => {

    var string = rawContent;
    var parser = new DOMParser();
    var domNode = parser.parseFromString(string, "text/html");
    const img = domNode.querySelectorAll("img");
    const tables = domNode.querySelectorAll("table");
    const atags = domNode.querySelectorAll("a");
    const italics = domNode.querySelectorAll("em");
    for (let i = 0; i < img.length; i++) {
      img[i].classList.add("sc-threelevel-component", "img-fluid", "rounded");
    }

    for (let i = 0; i < italics.length; i++) {
      italics[i].classList.add("sc-threelevel-component", "italic-style");
    }



    // for (let i = 0; i < atags.length; i++) {

    //   atags[i].classList.add("sc-threelevel-component", "linktopdf");
    // }


    for (let i = 0; i < tables.length; i++) {
      tables[i].classList.add("sc-threelevel-component", "table");
    }

    for (let i = 0; i < tables.length; i++) {
      let parent = tables[i].parentNode;
      let divWrapper = document.createElement("div");
      divWrapper.classList.add("sc-threelevel-component", "table-responsive", "tableborder")
      parent.replaceChild(divWrapper, tables[i]);
      divWrapper.appendChild(tables[i]);
    }

    return domNode.body.innerHTML;

  }
  getContents = () => {
    const level1FinalArray = []
    let level1Array = []
    let level2Array = []
    let level3Array = []
    // const expToggleArray = []

    let level1 = _.uniq(_.map(this.items, 'nypwebc_Level1Choice')).sort()

    level1.forEach((element) => {
      level1Array = []

      let level1Title = element
      let level1Content: any
      let level1Hint :any
      let level1ItemContent = _.filter(this.items, function (n: any) {
        return n.nypwebc_Level1Choice === element && !n.nypwebc_Level2Choice && !n.nypwebc_Level3Choice;
      });
      level1ItemContent.forEach((item) => {
        if (item.nypwebc_LevelContent) {
          level1Content = this.getHtml(item.nypwebc_LevelContent)
        }
        if (item.nypwebc_LevelHint) {
          level1Hint = this.getHtml(item.nypwebc_LevelHint)
        }

      });


      let level2Items = _.filter(this.items, function (n: any) {
        return n.nypwebc_Level1Choice === element && n.nypwebc_Level2Choice;
      });

      let level2 = _.uniq(_.map(level2Items, 'nypwebc_Level2Choice')).sort()
      level2Array = []
      if (level2.length > 0) {
        level2.forEach((element) => {

          let level2Title = element
          let level2Content: any
          let level2Hint: any

          let level2ItemContent = _.filter(this.items, function (n: any) {
            return n.nypwebc_Level2Choice === element && n.nypwebc_Level1Choice === level1Title && !n.nypwebc_Level3Choice
          });
          level2ItemContent.forEach((item) => {
            if (item.nypwebc_LevelContent) {
              level2Content = this.getHtml(item.nypwebc_LevelContent)
            }
            if (item.nypwebc_LevelHint) {
              level2Hint = this.getHtml(item.nypwebc_LevelHint)
            }
          });

          let level3 = _.filter(this.items, function (n: any) {
            return n.nypwebc_Level2Choice === element && n.nypwebc_Level1Choice === level1Title && n.nypwebc_Level3Choice;
          });

          level3= _.orderBy(level3, ['nypwebc_Level3Choice'],['asc']); 
          level3Array = []
          if (level3.length > 0) {

            level3.forEach((item) => {

              level3Array.push(
                <Fragment>
                  <div class="title">
                    {this.iconlocation === "left" ? <i class="dropdown icon"></i> :<i class="chevron icon down" style={{float:"right"}}></i> }
                    {item.nypwebc_Level3Choice}

                    {item.nypwebc_LevelHint ?
                        <Fragment>
                        <div class="ui icon button info-popup" >
                          <i class="info icon"></i>
                        </div>

                        <div class="ui fluid popup bottom left transition hidden">
                          <div class="raw-html-style" innerHTML={this.getHtml(item.nypwebc_LevelHint)} ></div>
                        </div>
                        </Fragment>
                      
                      : null}


                  </div>
                  <div class="content">
                    <div class="raw-html-style" innerHTML={this.getHtml(item.nypwebc_LevelContent)} ></div>
                  </div>
                </Fragment>

              )

              //level3FianlArray.push(level3Array)
            }


            )



          } //if

          level2Array.push(
            <div class="accordion" style={{ display: "block !important;" }}>
              <div class="title">
                {/* <i class="dropdown icon"></i> */}
                {this.iconlocation === "left" ? <i class="dropdown icon"></i> :<i class="chevron icon down" style={{float:"right"}}></i> }
                {level2Title}
                {level2Hint ?
                        <Fragment>
                        <div class="ui icon button info-popup" >
                          <i class="info icon"></i>
                        </div>

                        <div class="ui fluid popup bottom left transition hidden">
                          <div class="raw-html-style" innerHTML={this.getHtml(level2Hint)} ></div>
                        </div>
                        </Fragment>
                      
                      : null}

              </div>
              <div class="content">
                {level2Content ? <div class="raw-html-style" innerHTML={level2Content} ></div> : null}
                <div class="accordion">
                  {level3Array}
                </div>
              </div>
            </div>

          )
        })
      } //if


      level1Array.push(
        <div class="ui styled accordion">

          <div class="title">
            {/* <i class="dropdown icon"></i> */}
            {this.iconlocation === "left" ? <i class="dropdown icon"></i> :<i class="chevron icon down" style={{float:"right"}}></i> }
            {level1Title}
            {level1Hint ?
                        <Fragment>
                        <div class="ui icon button info-popup" >
                          <i class="info icon"></i>
                        </div>

                        <div class="ui fluid popup bottom left transition hidden">
                          <div class="raw-html-style" innerHTML={this.getHtml(level1Hint)} ></div>
                        </div>
                        </Fragment>
                      
                      : null}

          </div>
          <div class="content">
            {level1Content ? <div class="raw-html-style" innerHTML={level1Content} ></div> : null}
            {level2Array}
          </div>
        </div>

      )
      level1FinalArray.push(level1Array)
    });




    // if (this.exptoggle) {
    //   expToggleArray.push(
    //     <div class="ui grid">
    //       <div class="sixteen wide column">
    //         <a class="float-end" onClick={this.handleClick} style={{ paddingRight: "10px", paddingTop: "5px" }}  >
    //           <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABmJLR0QA/wD/AP+gvaeTAAABQ0lEQVRIie3Vv0oDQRAG8J8KmkaSdAqmsdEEH0PwHax8AiEvIIhWeQ8b64BFKh9AUEgTECtLFcFGg6DF7eHlXO9PSOkHA7dz38w37O7M8o8aWIr4trCaWb/ipUbONXwUETbxhQlGwc5qCHRxh0YRqYNxIPZqJBf4leI6GFYI2EFzHoGsSJroFnsR3gAHFXhgObd+w034nuAQFwUV9nAZeOPC8kuQHmYr4xugb76z+xMts9d9ILmmx9gP1ozEgZWKIu+59RRPWMd2sHs8V8y3eMQ6PsUujnK+K1zXFSnark/JNj1IOvhEMl5GmQJbfm/lXEgbrS858BTt4O8uSqAnab5Bwf8UpwpuWh75To6JxHhDyeQoRazCZkhYxq8kUmvYReLGZSKNOQTO/bw9E8l7tJElxPqk9GXLoR0sxRSPNeL/MYtvYfFDhGCJYBYAAAAASUVORK5CYII=" alt="Expand/collapse all" />
    //         </a>
    //       </div>
    //     </div>
    //   )
    // }

    return level1FinalArray

  }

  getExpandAll = ()=> {
    const expToggleArray = []


      expToggleArray.push(
        <div class="ui grid">
          <div class="sixteen wide column">
            <a class="float-end" onClick={this.handleClick} style={{ paddingRight: "10px", paddingTop: "5px" }}  >
              <img title="Expand/Collapse All" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABmJLR0QA/wD/AP+gvaeTAAABQ0lEQVRIie3Vv0oDQRAG8J8KmkaSdAqmsdEEH0PwHax8AiEvIIhWeQ8b64BFKh9AUEgTECtLFcFGg6DF7eHlXO9PSOkHA7dz38w37O7M8o8aWIr4trCaWb/ipUbONXwUETbxhQlGwc5qCHRxh0YRqYNxIPZqJBf4leI6GFYI2EFzHoGsSJroFnsR3gAHFXhgObd+w034nuAQFwUV9nAZeOPC8kuQHmYr4xugb76z+xMts9d9ILmmx9gP1ozEgZWKIu+59RRPWMd2sHs8V8y3eMQ6PsUujnK+K1zXFSnark/JNj1IOvhEMl5GmQJbfm/lXEgbrS858BTt4O8uSqAnab5Bwf8UpwpuWh75To6JxHhDyeQoRazCZkhYxq8kUmvYReLGZSKNOQTO/bw9E8l7tJElxPqk9GXLoR0sxRSPNeL/MYtvYfFDhGCJYBYAAAAASUVORK5CYII=" alt="Expand/collapse all" />
            </a>
          </div>
        </div>
      )

      return expToggleArray
  }

  handleClick = () => {
    this.expandallclick = !this.expandallclick
    this.expandbuttonclick=true;
    
    $('#' + this.componentid  +' .raw-html-style').removeClass('hidden')
    $('#' + this.componentid  +' .accordion').removeClass('hidden')
    if (this.expandallclick) {
            
      $('#' + this.componentid + ' .content').addClass('active')
      $('#' + this.componentid + ' .title').addClass('active')
            
    }
    else {
      $('#' + this.componentid + ' .content').removeClass('active')
      $('#' + this.componentid + ' .title').removeClass('active')
    }
  }

  initializeAccoridion = () => {

    // @ts-ignore
    $(".ui.accordion").accordion();
  }

  render() {
   

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"

      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }

    // let accordionid = this.componentid + '-' + 'accordion'
    return (

      this.isLoading ? <loader-component /> :

        this.header && this.items.length > 0 ?
          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle}>
              <div id={this.componentid} style={styleWithHeader}>
                { this.exptoggle ? this.getExpandAll():null}
                {this.getContents()}
                {/* {this.initializeAccoridion()} */}

              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle}>
            <div id={this.componentid} style={style}>
            {/* <div > {$.fn.jquery} </div> */}
              {this.getContents()}
              {/* {this.initializeAccoridion()} */}

            </div>
          </div>
    )
  }


}
